import { AxiosRequestConfig } from 'axios';
import { ConfirmOrderByCarDealerData } from 'request-config/vehicle-offer/vehicle-offer.type';
import { UniqueReferenceVehicleBrandsPayload } from '../../components/global-reference-vehicles/react-query/use-unique-reference-vehicle-brands/use-unique-reference-vehicle-brands.types';

class VehicleOfferRequestConfig {
  deactivate = (fahrzeugangeboteId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fahrzeugangebote/deactivate',
    data: {
      fahrzeugangeboteId
    }
  });

  getDriversPersonalConfigurations = (userId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fahrzeugangebote/getByUserId',
    data: {
      userId
    }
  });

  confirmOrderByCarDealer = (data: ConfirmOrderByCarDealerData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fahrzeugangebote/confirmOrderByCarDealer',
    data
  });

  getUniqueReferenceVehicleBrands = ({
    data,
    filterForServer,
    configurationTypeCode,
    accountId
  }: UniqueReferenceVehicleBrandsPayload): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fahrzeugangebote/getUniqueReferenceVehicleBrands',
    data: { ...data, search: filterForServer, accountId, configurationTypeCode }
  });
}

export const vehicleOfferRequestConfig = new VehicleOfferRequestConfig();
